<script setup lang="ts">
  import {computed} from 'vue';
  import {useI18n} from 'vue-i18n';
  import useCpBem from '~/composables/useCpBem';
  import CpText from '~/components/cp/CpText/CpText.vue';
  import CpButtonIcon from '~/components/cp/CpButtonIcon/CpButtonIcon.vue';
  import CpIconStandard from '~/components/cp/CpIcon/CpIconStandard/CpIconStandard.vue';

  const props = defineProps<{
      esd: boolean,
      stock: number,
      piecesToAdd: number,
      lowStock: boolean
  }>();

  defineEmits({
      click: null,
  });

  const {b, e} = useCpBem('cp-card-navigate-to-product-qty');
  const {t} = useI18n();
  const qtyText = computed(() => `${t('esd')} ${props.piecesToAdd} ${props.piecesToAdd > 1 ? 'piezas' : 'pieza'}`);
</script>

<template>
    <div :class="b" role="button" @click="$emit('click')">
        <div :class="e`main-container`">
            <CpIconStandard v-if="lowStock" icon="timer_outline" type="secondary" />
            <div :class="e`sub-container`">
                <CpText type="primary" variant="body-bold">
                    {{ qtyText }}
                </CpText>
                <CpText v-if="lowStock" type="secondary-dark" variant="body-bold">
                    {{ stock === 1 ? t('last_piece') : t('last_pieces', [stock]) }}
                </CpText>
                <CpText v-else type="neutral" variant="body-regular">
                    {{ esd ? t('in_stock') : t('available', [stock]) }}
                </CpText>
            </div>
        </div>
        <div
            :class="e`second-container`"
        >
            <CpButtonIcon
                kind="chevron"
                type="primary"
                @click="$emit('click')"
            />
        </div>
    </div>
</template>

<style scoped lang="scss">
    .cp-card-navigate-to-product-qty {
        border: $cp-border-standard;
        border-radius: $cp-border-radius;
        display: inline-flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: $cp-gutter;
        width: 100%;
        height: 68px;
        &__main-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        &__sub-container {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: $cp-gutter-xsmall;
            margin-left: $cp-gutter-small;
        }
        &__second-container {
            width: auto;
            display: flex;
            align-items: center;
            cursor: pointer;
        }
        &__right-space {
            margin-right: 4px;
        }
    }
</style>
<i18n locale="es-US">
    esd: 'Cantidad a agregar:'
    pieces: 'piezas'
    in_stock: 'En existencia'
    available: '{0} piezas disponibles'
    last_pieces: '¡Solo quedan {0} piezas!'
    last_piece: '¡Solo queda 1 pieza!'
</i18n>
